import React from "react";
import { Link } from "react-router-dom";

const LearnMore = () => {
  return (
    <Link className="learn-more-link" to="/skills">
      Learn More
    </Link>
  );
};

export default LearnMore;
